import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HttpHandler } from '@angular/common/http';
import { HelperService } from './services/helper.service';
import { GlobalErrorHandler } from './services/global-error.handler';
import { NgModule } from '@angular/core';
import { HttpService } from './helper/httpService';

import { PageNotFoundComponent } from './components/page-not-found/pagenotfound.component';

import { PcnBlockService } from './services/pcn-block.service';
import { ReasonService } from './services/reason.service';
import { StorageService } from './services/storage.service';
import { DocumentsService } from './services/documents.service';
import { QuestionService } from './services/question.service';
import { LetterService } from './services/letter.service';
import { AlertsService } from './services/alerts.service';
import { ReportsService } from './services/reports.service';
import { GlobalObservables } from '../../app.global.observer';
import { InterfaceService } from '../../authentication/services/interface.service';
import { EditorModule } from '@tinymce/tinymce-angular';
import { PolicyService } from './services/policy.service';

@NgModule({
  imports: [CommonModule, RouterModule, FormsModule, HttpClientModule],
  exports: [],
  declarations: [PageNotFoundComponent],
  providers: [
    HelperService,
    HttpService,
    PcnBlockService,
    ReasonService,
    PolicyService,
    DocumentsService,
    QuestionService,
    LetterService,
    AlertsService,
    ReportsService,
    InterfaceService,
    StorageService,
    GlobalErrorHandler,
    {
      provide: HttpService,
      useFactory: httpFactory,
      deps: [GlobalObservables],
    },
  ],
})
export class CommonAppModule {}
export function httpFactory(handler: HttpHandler, globalObs: GlobalObservables, router: Router) {
  return new HttpService(handler, globalObs, router);
}
